import { render } from "./browser.vue?vue&type=template&id=2c3fe503&scoped=true&lang=pug"
import script from "./browser.vue?vue&type=script&lang=js"
export * from "./browser.vue?vue&type=script&lang=js"

import "./browser.vue?vue&type=style&index=0&id=2c3fe503&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c3fe503"]])

export default __exports__